import { ReadCsvDataWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('ReadCsvData')
export class RadCsvDataConnectorProvider extends ConnectorProvider<ReadCsvDataWorkflowNode> {}
